module.exports = __webpack_public_path__ + "static/img/PaternityTest_Artboard 3.ff5ef6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/paternitytesting/PaternityTest_Artboard 3.jpg
// module id = vuwN
// module chunks = 0